import * as React from 'react';

import {Illustration} from 'shells/illustrations/illustration';

import {FeatureGatePageWrapper} from './feature-gate-page-wrapper';

export function AuditLogFeatureGate() {
    return (
        <FeatureGatePageWrapper
            header='Unlock powerful tracking'
            subHeader='Upgrade your plan to monitor changes, ensure accountability, and protect your CRM data.'
            bullets={[
                'See who made changes to contacts, leads, and accounts.',
                'Monitor when key information is added, updated, or deleted.',
                'Gain insights with enhanced analytics and reporting.',
            ]}
            feature='auditLog'
            icon={<Illustration src='person-working' />}
        />
    );
}
